<script setup lang="ts">
import Customer from "@/customer/interfaces/Customer";
import Beneficiary from "@/customer/interfaces/Beneficiary";
import {consumerDetailsApi} from "@/container";

const props = defineProps<{
    customer: Customer,
    /** The consumer to emulate; the customer itself when omitted. */
    consumer?: Beneficiary | Customer | null
}>();

/**
 * Emulate the detection of the consumer (a beneficiary emulates the beneficiary file
 * opened in the LGO, not its insured customer).
 *
 * The file carries the NIR for superadmins only; the HDS serves it to the pharmacy in
 * the consumer's details, and it goes along — the insured's, for a beneficiary, as the
 * Vitale card holds it. The emulated patient then reaches the popup as a card read
 * would, ADAC included; the shell has always taken a `nir` from what it is sent. A NIR
 * that cannot be read leaves the emulation as it was, matched on the insured identifier.
 */
const emulateDetection = async () => {
    const consumer = JSON.parse(JSON.stringify(props.consumer ?? props.customer));
    const nir = consumer.consumer_key
        ? await consumerDetailsApi().details(consumer.consumer_key)
            .then(details => details.insured_identifier?.nir || null)
            .catch(() => null)
        : null;

    window.ipcRenderer.send('emulate-detection', nir ? {...consumer, nir} : consumer);
};
</script>

<template>
  <div class="bg-white rounded-lg flex cursor-pointer" @click="emulateDetection">
    <div class="px-3 flex items-center text-primary font-bold">
      <p>
        Simuler lecture
      </p>
    </div>
    <img src="@/assets/images/carte-vitale.png" alt="carte vitale" class="w-12 object-contain">
  </div>
</template>

<style scoped>

</style>
